import { Anchor } from '@components/RichTextAndTypography'
import theme from '@themes/index'
import styled from 'styled-components'
import { background, layout, position, space } from 'styled-system'

export const StyledHeader = styled.header`
  ${background}
  ${position}
  ${space}
  ${layout}
`

export const StyledAnchor = styled(Anchor)`
  transition: color .25s;

  @media (min-width: ${theme.sizes.maxWidth.medium}) {
    &:hover {
      color: ${theme.colors.tanLight};
    }
  }
`
